import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
    {
    path: "*",
    name :"404",
    component : NotFound
  }
];

const router = new VueRouter({
  mode : 'history',
  routes,
  scrollBehavior(to,from, savedPosition)  {
    if (savedPosition){
      return savedPosition
     }
    else{
      const position = {}
      if (to.hash){
        position.selector = to.hash;
        position.offset= {y : 49}
        if (document.querySelector(to.hash)){
          
          return position
        }
        return false;
      }
    }
   }
});

export default router;
